module.exports = __webpack_public_path__ + "media/images/front/icons/contents-aed2d61ba2b7f8cbad0636a5399c610a.png";